module.exports = __webpack_public_path__ + "6cf6010233adeaa060196e754e464cac.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/huadongkeji.png
// module id = 297
// module chunks = 3